import React from "react";
import { useIsAuthenticated } from "@hilma/auth-core";

import { PublicOnlyRouteProps } from "../types";

import PrivateRoute from "./PrivateRoute";

const PublicOnlyRoute: React.FC<PublicOnlyRouteProps> = ({
  component: Component,
  ...rest
}) => {
  const isAuthenticated = useIsAuthenticated();

  if (isAuthenticated) return <PrivateRoute component={Component} {...rest} />;

  return typeof Component === "function" ? <Component /> : Component;
};

export default PublicOnlyRoute;
